// Online ordering switch (#1221). The /order cart is parked: "Order Online"
// and /order itself send customers to the form-first plan wizard instead.
// Flip CART_ORDERING_ENABLED back to true to bring the cart back.

export const CART_ORDERING_ENABLED = false;

export const ORDER_ONLINE_HREF = CART_ORDERING_ENABLED ? "/order" : "/plan?service=drop_off";

/** Where /order sends a visitor while the cart is parked. Keeps UTM and click
 * ids, drops the cart-only `source` and `service` params. */
export function orderRedirectTarget(search: string): string {
  const params = new URLSearchParams(search);
  const service = params.get("service") === "corporate" ? "corporate" : "drop_off";
  const next = new URLSearchParams({ service });
  params.forEach((value, key) => {
    if (key !== "service" && key !== "source") next.append(key, value);
  });
  return `/plan?${next.toString()}`;
}
